import React from 'react'
import {Switch, Route} from 'react-router-dom'
import NavBar from '../containers/nav-bar-container'
import Search from './search'
import Report from './report'
import Analysis from './analysis'
import InfoPanel from '../containers/info-panel-container'
import MonitoringTranslations from './monitoring-translations'
import {isAuthenticated} from '../util/helpers'

export default (props) => (
  <div>
    <section className='cs-header-nav'>
      <NavBar {...props}/>
    </section>
    <section className='main'>
      <Switch>
        <Route exact path='/search' render={renderSpecifiedComp}/>
        <Route exact path='/search/report' render={renderSpecifiedComp}/>
        <Route path='/analysis' render={renderSpecifiedComp}/>
        <Route path='/monitoringTranslations' render={renderSpecifiedComp}/>
      </Switch>
      <InfoPanel/>
    </section>
  </div>
)

const renderSpecifiedComp = function (props) {
  let Comp = null
  if (props.location.pathname === '/search') {
    Comp = Search
  } else if (props.location.pathname === '/search/report') {
    Comp = Report
  } else if (props.location.pathname === '/analysis') {
    Comp = Analysis
  } else if (props.location.pathname === '/monitoringTranslations') {
    Comp = MonitoringTranslations
  }
  if (isAuthenticated() && Comp) {
    return <Comp {...props}/>
  } else {
    props.history.push('/')
    return null
  }
}



// WEBPACK FOOTER //
// ./src/views/cs-connect-app.js